<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fronttitle"><a id="pxi"></a> List of Illustrations</h1>
<p class="center"><em>(Found at <span href="#/c22" title="Link target outside of Sample">[&gt;]</span>)</em></p>
<p class="center">Anaïs Nin with manuscript volumes of the Diary</p>
<p class="center">In Japan</p>
<p class="center">In Cambodia</p>
<p class="center">In Tahiti</p>
<p class="center">In Morocco</p>
<p class="center">In Los Angeles</p>
<p class="center">In Paris, being photographed for German television</p>
<p class="center">Giving a talk in St. Clement’s Church</p>
<p class="center">With students at home in Los Angeles</p>
<p class="center">At an Esalen Institute seminar</p>
<p class="center">In Puerto Vallarta, Mexico</p>
<p class="center">At Dartmouth College with Justice William O. Douglas</p>
<p class="center">In Bali</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?7751409b